import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import Icon from '@components/Icon';
import { Button, Radio, Tooltip } from 'antd';
import stores from '@stores';
import { windowDark, windowLight } from '@utils/windowsIcon';
import deviceFrames from '@utils/deviceFrames';

export default observer(() => {
    const handelChange = (e) => {
        const { value } = e.target;
        stores.option.setFrame(value);
        if (value === 'macbookpro16') {
            stores.option.setPaddingBg('#000000');
        }
    }

    // 渲染设备框架项
    const renderDeviceItem = (item) => {
        // 处理基础框架特殊情况
        if (item.id === 'none') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-10 w-[85%] rounded-md shadow-md -mt-1 -ml-1"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'light') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 border-2 border-white/80 h-10 w-[85%] rounded-md shadow-md -mt-1 -ml-1"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'dark') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 border-2 border-black/40 h-10 w-[85%] rounded-md shadow-md -mt-1 -ml-1"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'macosBarLight') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-10 w-[85%] rounded-sm shadow-md mt-2 ml-3 overflow-hidden">
                            <div
                                className="h-1.5 bg-white/90 px-0.5 flex items-center gap-[1px] before:block before:rounded-full before:w-0.5 before:h-0.5 before:bg-red-500 after:w-0.5 after:h-0.5 after:bg-green-500"
                            >
                                <i className="block w-0.5 h-0.5 bg-yellow-500"></i>
                            </div>
                        </div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'macosBarDark') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-10 w-[85%] rounded-sm shadow-md mt-2 ml-3 overflow-hidden">
                            <div
                                className="h-1.5 bg-black/90 px-0.5 flex items-center gap-[1px] before:block before:rounded-full before:w-0.5 before:h-0.5 before:bg-red-500 after:w-0.5 after:h-0.5 after:bg-green-500"
                            >
                                <i className="block w-0.5 h-0.5 bg-yellow-500"></i>
                            </div>
                        </div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'windowsBarLight') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-14 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-12 w-[85%] rounded-sm shadow-md mt-2 ml-3 overflow-hidden">
                            <div className="bg-white/90 px-0.5">
                                <div className="h-2.5 bg-no-repeat bg-[right_center] bg-[auto_100%]" style={{
                                backgroundImage: `url(${ windowDark })`,
                            }} />
                            </div>
                        </div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'windowsBarDark') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-14 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-12 w-[85%] rounded-sm shadow-md mt-2 ml-3 overflow-hidden">
                            <div className="bg-black/90 px-0.5">
                                <div className="h-2.5 bg-no-repeat bg-[right_center] bg-[auto_100%]" style={{
                                    backgroundImage: `url(${ windowLight })`,
                                }} />
                            </div>
                        </div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'lightGray') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 border-2 border-gray-200 h-10 w-[85%] rounded-md shadow-md -mt-1 -ml-1"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'darkGray') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 border-2 border-gray-600 h-10 w-[85%] rounded-md shadow-md -mt-1 -ml-1"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'coloredBorder') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-10 w-[85%] rounded-md shadow-md -mt-1 -ml-1 border-2" style={{
                            borderColor: '#ff5f6d'
                        }}></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'gradientBorder') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 p-0.5 rounded-md -mt-1 -ml-1 w-[85%]">
                            <div className="bg-slate-300/40 h-9 w-full rounded-sm"></div>
                        </div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'roundedCorners') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-10 w-[85%] rounded-xl shadow-md -mt-1 -ml-1"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } else if (item.id === 'shadowed') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-10 w-[85%] rounded-md -mt-1 -ml-1 shadow-lg shadow-blue-500/30"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } 
        // 新增可爱框架 - 波点边框
        else if (item.id === 'dottedBorder') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-slate-300/40 h-9 w-[80%] rounded-md mt-1.5 mx-auto border-4 border-dashed border-pink-300"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } 
        // 新增可爱框架 - 爱心装饰
        else if (item.id === 'heartDecorated') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full relative">
                        <div className="bg-slate-300/40 h-8 w-[75%] rounded-md mt-2 mx-auto border-2 border-red-300"></div>
                        <div className="absolute -top-0.5 right-2 text-red-400 text-sm">❤</div>
                        <div className="absolute bottom-0 left-2 text-red-400 text-sm">❤</div>
                        <div className="absolute top-3 -right-0.5 text-red-400 text-xs">❤</div>
                        <div className="absolute top-3 -left-0.5 text-red-400 text-xs">❤</div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } 
        // 新增可爱框架 - 气泡框
        else if (item.id === 'bubbleFrame') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-14 overflow-hidden w-full relative">
                        <div className="bg-slate-300/40 h-8 w-[72%] rounded-full shadow-md mt-2 ml-3 border border-blue-200"></div>
                        <div className="absolute bottom-3 left-[15%] w-4 h-4 rounded-full bg-slate-300/40 shadow-md border border-blue-200"></div>
                        <div className="absolute bottom-1.5 left-[10%] w-2.5 h-2.5 rounded-full bg-slate-300/40 shadow-md border border-blue-200"></div>
                        <div className="absolute top-2 right-3 w-3 h-3 rounded-full bg-slate-300/40 shadow-md border border-blue-200"></div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } 
        // 新增可爱框架 - 星星装饰
        else if (item.id === 'starDecorated') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full relative">
                        <div className="bg-slate-300/40 h-8 w-[75%] rounded-md mt-2 mx-auto border border-yellow-300"></div>
                        <div className="absolute -top-1 right-1 text-yellow-400 text-sm">⭐</div>
                        <div className="absolute bottom-0 left-1 text-yellow-400 text-sm">⭐</div>
                        <div className="absolute top-2 -right-0.5 text-yellow-400 text-xs">✨</div>
                        <div className="absolute top-6 -left-0.5 text-yellow-300 text-xs">✨</div>
                        <div className="absolute top-0 left-1/2 text-yellow-400 text-xs">⭐</div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } 
        // 新增可爱框架 - 彩虹边框
        else if (item.id === 'rainbowBorder') {
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full">
                        <div className="bg-gradient-to-r from-red-500 via-yellow-500 via-green-500 via-blue-500 to-purple-500 p-[5px] rounded-md mt-1 mx-auto w-[80%]">
                            <div className="bg-slate-300/40 h-[calc(100%-10px)] w-full rounded-sm"></div>
                        </div>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        } 
        else {
            // 默认样式
            return (
                <div className="flex flex-col items-center group relative">
                    <div className="bg-gray-300/30 rounded-md h-12 overflow-hidden w-full flex items-center justify-center">
                        <span className="text-xs text-gray-500">{item.name}</span>
                    </div>
                    <span className="text-xs text-gray-500 mt-1 truncate w-full text-center">{item.name}</span>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black/75 text-white text-xs rounded px-2 py-1 pointer-events-none whitespace-nowrap">
                        {item.name}
                    </div>
                </div>
            );
        }
    };

    // 只使用基础框架
    const basicFrames = deviceFrames.basicFrames.items;
    
    return (
        <div className="[&_label]:font-semibold [&_label]:text-sm bg-white/5 rounded-md p-3 mb-3 backdrop-blur-sm shadow-sm">
            <div className="flex justify-between items-center mb-2">
                <label className="flex items-center">
                    <Icon.Monitor size={16} className="mr-2 text-purple-500 dark:text-purple-400" />
                    图片边框
                </label>
            </div>
            <div className="py-2 [&_.ant-radio-wrapper_span]:p-0 [&_.ant-radio-wrapper_span]:px-1">
                <Radio.Group
                    rootClassName="grid grid-cols-3 gap-3"
                    onChange={handelChange}
                    value={stores.option.frame}
                >
                    {basicFrames.map(item => (
                        <Radio
                            key={item.id}
                            className="[&_.ant-radio]:hidden [&_span]:mr-0 [&_span]:block [&_span]:w-full hover:shadow-md transition-shadow" 
                            value={item.id}
                        >
                            {renderDeviceItem(item)}
                        </Radio>
                    ))}
                </Radio.Group>
            </div>
        </div>
    );
});